import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { forceRenameProcedure } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

export async function forceUpdateProcedureName({
  accountId,
  procedureId,
}: TVariables): Promise<TResult> {
  const response = await fetch(forceRenameProcedure(accountId, procedureId), {
    method: 'PUT',
    headers: {
      Authorization: getTokenWithType(),
      'Content-Type': 'application/json',
    },
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: string;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  accountId: number;
  procedureId: number;
};

type TSnapshot = unknown;

function useForceRenameProcedure(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async (params: TVariables) => {
    const { accountId } = params;
    const renamedResult = await forceUpdateProcedureName(params);
    if (renamedResult.Data) {
      queryClient.invalidateQueries(
        ['get_procedure_builder_procedures', accountId],
        {
          refetchInactive: true,
        },
      );
      queryClient.invalidateQueries(['get_procedure', accountId], {
        refetchInactive: true,
      });
    } else if (renamedResult.Errors) throw renamedResult;
    return renamedResult;
  });
}

export { useForceRenameProcedure };
